import React from "react"
import {
  getGenerationPresetFields,
  parseColorPalette,
  translateCreativity,
  translateDecorStyle,
  translateRoomType,
  translateTheme,
} from "./generationPresetDisplay"

const GenerationPresetsFooter = ({
  gen,
  lang = "en",
  includeCreativity = false,
}) => {
  const presets = getGenerationPresetFields(gen)
  const colors = parseColorPalette(presets.color_palette)
  const na = lang === "ar" ? "غير متوفر" : "N/A"

  return (
    <div className="sketch-footer">
      <div>
        <div style={{ color: "#666", fontSize: "14px" }}>
          {lang === "ar" ? "نوع الغرفة:" : "Room Type:"}
        </div>
        <div>
          {presets.room_type ? translateRoomType(presets.room_type, lang) : na}
        </div>
      </div>

      <div>
        <div style={{ color: "#666", fontSize: "14px" }}>
          {lang === "ar" ? "نمط الديكور:" : "Decor Style:"}
        </div>
        <div>
          {presets.decor_style
            ? translateDecorStyle(presets.decor_style, lang)
            : na}
        </div>
      </div>

      <div>
        <div
          style={{
            color: "#666",
            fontSize: "14px",
            marginBottom: "8px",
          }}
        >
          {lang === "ar" ? "لوحة الألوان:" : "Color Palette:"}
        </div>
        {colors.length > 0 ? (
          <div style={{ display: "flex", gap: "8px" }}>
            {colors.map((color) => (
              <div
                key={color}
                style={{
                  width: "20px",
                  height: "10px",
                  borderRadius: "4px",
                  backgroundColor: color,
                }}
              />
            ))}
          </div>
        ) : (
          <div>{na}</div>
        )}
      </div>

      <div>
        <div style={{ color: "#666", fontSize: "14px" }}>
          {lang === "ar" ? "النمط العام:" : "Theme:"}
        </div>
        <div>
          {presets.room_theme ? translateTheme(presets.room_theme, lang) : na}
        </div>
      </div>

      {includeCreativity ? (
        <div>
          <div style={{ color: "#666", fontSize: "14px" }}>
            {lang === "ar" ? "الأسلوب الإبداعي:" : "Creativity:"}
          </div>
          <div>
            {presets.creativity
              ? translateCreativity(presets.creativity, lang)
              : na}
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default GenerationPresetsFooter
